import { render, staticRenderFns } from "./DashboardProductStatus.vue?vue&type=template&id=b76fbbe2&scoped=true&"
import script from "./DashboardProductStatus.vue?vue&type=script&lang=js&"
export * from "./DashboardProductStatus.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProductStatus.vue?vue&type=style&index=0&id=b76fbbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76fbbe2",
  null
  
)

export default component.exports